class FoodSections {
  constructor() {
    const self = this;

    $(function() {
      self.setActiveSection('wet');
      self.setOffsets();
      self.initializeListeners();
    })
  }

  initializeListeners() {
    const self = this;
    document.querySelectorAll('.landing-sticky__nav__link').forEach(navSection => {
      navSection.addEventListener('click', function() {
        self.setActiveSection(this.dataset.foodSection);
      });
    });
    window.addEventListener("resize", this.setOffsets.bind(this));

    // watch the "more info" links
    document.querySelectorAll('.landing-sticky__body-primary-recipe-card-more-info-toggle').forEach(recipeModal => {
      recipeModal.addEventListener('click', function() {
        self.showFullRecipeModal(this.dataset.recipe);
      });
    });

    document.querySelectorAll('.landing-sticky__more-recipe-info-exit').forEach(exitButton => {
      exitButton.addEventListener('click', function() {
        self.exitRecipe(this.dataset.recipe);
      });
    })
  }

  showFullRecipeModal(recipe) {
    // set the appropriate section to 'active'
    const fullRecipeModals = document.querySelectorAll('.landing-sticky__more-recipe-info');
    fullRecipeModals.forEach(modal => {
      $('header').addClass('modal-is-active');
      $('body').addClass('modal-is-active');
      if (modal.dataset.recipe === recipe) {
        $(modal).addClass('active');
      }
      else {
        $(modal).removeClass('active');
      }
    });
  }

  exitRecipe(recipe) {
    document
      .querySelectorAll('.landing-sticky__more-recipe-info')
      .forEach(modal => $(modal).removeClass('active'));
    $('header').removeClass('modal-is-active');
    $('body').removeClass('modal-is-active');
  }

  setActiveSection(activeSection) {
    // set the appropriate section to 'active'
    const sectionTitles = document.querySelectorAll('.landing-sticky__nav__link');
    sectionTitles.forEach(title => {
      if (title.dataset.foodSection === activeSection) {
        $(title).addClass('active');
      }
      else {
        $(title).removeClass('active');
      }
    });

    // show the appropriate section
    const sections = document.querySelectorAll('.landing-sticky__body-inner');
    sections.forEach(section => {
      if (section.dataset.foodSection === activeSection) {
        $(section).show();
      }
      else {
        $(section).hide();
      }
    })
  }

  makeAndRemoveStickyNav() {
    window.addEventListener("scroll", () => {
      requestAnimationFrame(() => {

        const headerBarHeight = document.getElementById('main-header')
        if (headerBarHeight){
          const headerBarHeight = document.getElementById('main-header').offsetHeight;
        }else{
          return
        }

        if (window.pageYOffset > (this.stickyOffSet - headerBarHeight) && window.pageYOffset < this.bottomOfSection) {
          this.stickyNav.classList.add('sticky')
          $(this.stickyNav).parents().css("overflow", "visible")
        }
        else {
          this.stickyNav.classList.remove('sticky')
        }
      })
    })
  }

  setOffsets() {
    this.sectionWithStickyNav = document.getElementById('food');
    this.stickyNav = document.getElementById('sticky-header');
    if(!this.stickyNav) return;
    this.stickyOffSet = this.stickyNav.offsetTop;
    this.bottomOfSection = (this.sectionWithStickyNav.offsetHeight) + this.stickyOffSet;

    this.makeAndRemoveStickyNav();
  }
}

const foodSections = new FoodSections();

/* HOME PAGE DEEP ANCHOR LINKING */
var goToAnchorLink = function() {

  // get the anchor from the url, i.e. https://smallforsmalls.com/#food/treats => `food/treats`
  var hash = window.location.hash.substr(1);

  // split it by slashes, i.e. `food/treats` => [`food`, `treats`]
  var splitHash = hash.split('/');

  // item one is the section by ID => find it and go there
  var mainSection = splitHash[0];
  var subsection = splitHash[1];

  if (!mainSection || mainSection === '!') return;

  // get the scroll position of the main section (including offset for sticky header)
  var mainSectionPosition = document.querySelector('#'+mainSection).getBoundingClientRect().y;
  var headerBarHeight = document.getElementById('main-header').offsetHeight;
  var finalScrollPosition = mainSectionPosition - headerBarHeight;

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'
  }
  window.scrollTo(0, finalScrollPosition);

  // now for the subsection
  if (mainSection === 'food') {
    if (subsection && ['freeze-dried', 'wet', 'treats', 'kibble'].includes(subsection)) {
      foodSections.setActiveSection(subsection);
    }
  }
}

$(function() {
  if (location.hash) {
    setTimeout(function() {
      window.scrollTo(0, 0);
      goToAnchorLink();
    }, 1);
  }
});
